var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotificationsEmpty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.73 15.926v-4.92a4.4 4.4 0 0 0-.389-1.87 3.07 3.07 0 0 0-1.109-1.318q-.74-.512-1.732-.512-.993 0-1.732.512-.72.472-1.11 1.319a4.4 4.4 0 0 0-.389 1.87v4.92zm1.635-.846L18 16.733v.807H5v-.807l1.635-1.653v-4.074q0-1.928.953-3.326.973-1.436 2.705-1.87v-.57q0-.511.35-.876Q10.994 4 11.5 4t.866.364q.36.365.36.876v.57q1.713.434 2.686 1.89.953 1.397.953 3.306zM11.5 20q-.662 0-1.148-.472a1.53 1.53 0 0 1-.487-1.142h3.27q0 .67-.487 1.142A1.6 1.6 0 0 1 11.5 20",
  clipRule: "evenodd"
})));
export default SvgNotificationsEmpty;